<!--详情页面-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false"
    :append-to-body="true"
    custom-class="medium-dialog">
    <el-table
      :data="tableData"
      size="mini"
      stripe
      show-summary
      :summary-method="getSummaries"
      border
      style="width: 100%;">
      <el-table-column
        type="index"
        width="50"
        label="序号"
        align="center">
      </el-table-column>
      <el-table-column
        prop="adddate"
        label="使用时间"
        align="center"  width="135"
        header-align="center"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="erpserial"
        label="订单号"
        align="center"
        header-align="center"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="comboitem"
        label="编码"
        align="left"
        header-align="center" v-if="combo"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="combonam"
        label="名称"
        align="left"
        header-align="center" v-if="combo"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="combonum" width="90"
        label="数量" v-if="combo"
        align="left"
        header-align="center">
      </el-table-column>
      <el-table-column
        prop="money"
        label="金额"  width="100"
        align="left"
        header-align="center">
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
  import {getlist} from '@/api/set/machinecouponhis';

  export default {
    name: 'MachinecouponhisList',
    data() {
      return {
        title: '',
        dialogSeeVisible: false,
        tableData: []
      }
    },
    props: {
      combo: false,
    },
    methods: {
      //汇总
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (index === 2||column.property=='comboitem'||column.property=='comboname') {
            sums[index] = ""
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
      show(title) {
        this.title = title
        this.dialogSeeVisible = true
      },
      initData(couponguid) {
        getlist({couponguid: couponguid, sort: "adddate", order: "desc"}).then(response => {
          this.tableData = response.data.obj
        })
      }

    },
    mounted() {

    },
    components: {}

  }
</script>

<style scoped>
  /*.query-table td {*/
  /*border: 1px solid #E0DFDF;*/
  /*vertical-align: center;*/
  /*height: 22px;*/
  /*line-height: 16px;*/
  /*padding: 2px;*/
  /*font-size: 12px;*/
  /*}*/

  /*.query-table td.content {*/
  /*text-align: center;*/
  /*}*/

  /*.noborder td {*/
  /*border: none;*/
  /*font-size: 12px;*/
  /*}*/


</style>





// WEBPACK FOOTER //
// src/components/set/salefavour/MachinecouponhisList.vue